import React from "react";
import "./App.css";
import Logout from "./components/Logout";
import Home from "./components/Home";
import { Router, Switch, Route } from "react-router-dom";
import SignInSide from "./components/SignInSide";
import NavBar from "./components/Navbar/NavBar";
import Profile from "./components/Profile";
import NotFoundPage from "./components/NotFoundPage";
import Service from "./components/Service";
import Details from "./components/Details";
import Footer from './components/Footer';

import Users from './components/AdminFolder/Users';
import ServiceRecord from './components/AdminFolder/ServiceRecord';
import DashBoard from './components/AdminFolder/DashBoard';
import Admin from './components/AdminFolder/Admin.js';
import Themes from './components/AdminFolder/Themes';




import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

import history from "./history";

import SignUp2 from "./components/SignUp2";
import NeededTheme from "./components/AdminFolder/NeededTheme";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
    };
  }

  render() {
    return (
      
      <Router history={history}>
        
        <NavBar />
        <Footer/>
      
        <Switch>
          <Route path="/" exact>
             <Home />
          </Route>

          <Route path="/login" exact>
            <SignInSide />
          </Route>

          <Route path="/register" exact>
            <SignUp2 />
          </Route>

          <Route path="/welcome" exact>
            <Home />
          </Route>

          <Route path="/profile" exact>
            <Profile />
          </Route>

          <Route path="/service" exact>
            <Service />
          </Route>

          <Route path="/details" exact>
            <Details />
          </Route>

          <Route path="/logout" exact>
            <Logout />
          </Route>


          <Route path="/admin" exact>
            <Admin/>
            <DashBoard/>
           
          </Route>

         

          <Route path="/admin/AllUsers" exact>
            <Admin />
            <Users />
          </Route>


          <Route path="/admin/AllTheme" exact>
          <Admin />
            <Themes />
          </Route>

          <Route path="/admin/AllService" exact>
          <Admin />
            <ServiceRecord />
          </Route>

          <Route path="/admin/need" exact>
          <Admin/>
          
             <NeededTheme/>
          </Route>

          <Route path="/admin/logout" exact>
            <Logout />
          </Route>

          <Route path="*" component={NotFoundPage} />
        </Switch>
     
      </Router>

    );
  }
}

export default App;
